/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useStore from '../../context';

import {
  ActiveDeactivatedConfirm,
  BranchCount,
  ChangeEmail,
  UserDetailsWrapper,
  UserInfo,
  PromoCode,
  LinkedCode,
  BillingExpirationDate,
  UserBillingEmail,
} from "components";
import { AcceptUserModal } from "components/modals/acceptModal";
import { UsersInformation } from "./users-information";
import { UserDefaultPlan } from "./userDefaultPlan";
import { UserBillingEmails } from "./userBillingEmails";
import { BUTTONS_TYPE, USER_ID, BILLING_EMAIL_ERROR_MSG, DEALER_CODE_ERROR_MSG, AMBASSADOR_CODE_ERROR_MSG, CONTRACT_NUMBER_ERROR_MSG } from "Constants";
import * as Api from "service";
import { useTranslation } from "localization/translation";
import { getQueryParam } from "helpers/getQueryParam";
import { UserBranches } from "./userBranches";
import { ClipLoader } from "react-spinners";

export default function UserDetails() {
  const location = useLocation();
  const translation = useTranslation();
  const { setRemove, setErrorMsg } = useStore();

  const [userDetails, setUserDetails] = useState({});
  const [isOpenAction, setIsOpenAction] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [userId, setUserId] = useState(null);
  const [actionUserId, setActionUserId] = useState(null);
  const [isUserActive, setIsUserActive] = useState(null);
  const [userDataActivity, setUserDataActivity] = useState(null);
  const [isBranchCountMode, setIsBranchCountMode] = useState(false);
  const [isPromoCodeMode, setIsPromoCodeMode] = useState(false);
  const [isDealerCodeMode, setIsDealerCodeMode] = useState(false);
  const [isAmbassadorCodeMode, setIsAmbassadorCodeMode] = useState(false);
  const [isContractNumberMode, setIsContractNumberMode] = useState(false);
  const [isBillingEmailMode, setIsBillingEmailMode] = useState(false);
  const [isChangeBillingExpirationDateMode, setIsChangeBillingExpirationDateMode] = useState(false);
  const [isChangeEmailMode, setIsChangeEmailMode] = useState(false);
  const [userBranches, setUserBranches] = useState([]);
  const [isOpenBranchAction, setIsOpenBranchAction] = useState(false);
  const [branchActionType, setBranchActionType] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [isBranchActive, setIsBranchActive] = useState(null);
  const [isBranchActionActive, setBranchIsActionActive] = useState(false);
  const [analyticsDate, setAnalyticsDate] = useState(null);
  const [lang, setLang] = useState("en");
  const [activateLoading, setActivateLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [isOpenEditUserDefaultPlanModal, setIsOpenEditUserDefaultPlanModal] = useState(false);
  const [userOriginDefaultPlan, setUserOriginDefaultPlan] = useState(null);
  const [userDefaultPlan, setUserDefaultPlan] = useState(null);
  const [loadingUpdateUserDefaultPlan, setLoadingUpdateUserDefaultPlan] = useState(false);
  const [errorUserDefaultPlan, setErrorUserDefaultPlan] = useState(null);
  const [userBillingEmailsData, setUserBillingEmailsData] = useState([]);
  const [selectedBillingEmail, setSelectedBillingEmail] = useState(null);
  const [isAdminBillingEmail, setIsAdminBillingEmail] = useState(false);
  const [isBillingEmailEditMode, setIsBillingEmailEditMode] = useState(false);
  const [isSendAdminEmail, setIsSendAdminEmail] = useState(true);
  const [loadingUserBillingEmailsDelete, setLoadingUserBillingEmailsDelete] = useState(false);
  const [isTogglingSendAdminBillingEmail, setIsTogglingSendAdminBillingEmail] = useState(false);

  const paramsUserId = getQueryParam(location, USER_ID);

  const onClickHandler = async () => {
    setActivateLoading(true);
    const updateUserDetails = async () => {
      const { data } = await Api.main.getUserDetails(userId);
      setUserDetails(data);
    };
    if (isUserActive && !userDetails?.userInformation?.email_verified) {
      return Api.main
        .activateUser({
          userId,
          suggestedBranchCount: companyInformation?.branches_count,
          lang,
        })
        .then(() => {
          setIsOpenAction(false);
          updateUserDetails();
          setActionUserId(null);
          setIsUserActive(null);
        })
        .finally(() => {
          setActivateLoading(false);
        });
    } else {
      Api.main
        .setUserStatus({
          userId: actionUserId,
          active: isUserActive,
        })
        .then(() => {
          setIsOpenAction(false);
          updateUserDetails();
          setActionUserId(null);
          setIsUserActive(null);
        })
        .finally(() => {
          setActivateLoading(false);
        });
    }
  };

  const fetchUserBranches = async (id) => {
    const { data } = await Api.main.getUserBranches(id, analyticsDate);
    setUserBranches(data);
  };

  const fetchPlans = async () => {
    const { data } = await Api.main.getPlans();
    setPlans(data?.plans || []);
    setCurrencies(data?.currencies || []);
  };

  const handleBranchActivation = async () => {
    await Api.main
      .setUserBranchAction({
        id: branchId,
        data: { status: isBranchActive },
      })
      .then(() => {
        setIsOpenBranchAction(false);
        fetchUserBranches(userId);
      });
  };

  const fetUserDetails = async (id) => {
    setLoading(true);
    const { data } = await Api.main.getUserDetails(id);
    setUserDetails(data);
    setLoading(false);
  };

  const getDate = (backDate) => {
    if (backDate == null || backDate === "") {
      return "N/A";
    }

    const date = new Date(backDate);
    if (Number.isNaN(date.getTime())) {
      return "N/A";
    }

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  const {
    companyInformation,
    userInformation,
    remainingBranchesCount,
    companyUsers,
    userBillingEmails,
    billingEmailSettings,
  } = userDetails;

  const getUserDefaultPlan = (userDefaultPlan) => {
    const currency = currencies?.find((c) => c.code === userDefaultPlan?.currency);
    const data = {
      plan_name: userDefaultPlan?.name,
      plan_id: userDefaultPlan?.plan_id,
      plan_type: userDefaultPlan?.billing_period,
      price: userDefaultPlan?.price_paid,
      currency: currency?.id,
      currency_code: currency?.code,
      trial_period_days: userDefaultPlan?.trial_period_days,
      is_use_free_trial: userDefaultPlan?.is_use_free_trial,
      free_trial_start_at: userDefaultPlan?.free_trial_start_at,
      free_trial_end_at: userDefaultPlan?.free_trial_end_at,
      billing_expiration_date: userDefaultPlan?.billing_expiration_date,
      subscription_starts_at: userDefaultPlan?.subscription_starts_at,
      subscription_ends_at: userDefaultPlan?.subscription_ends_at,
      is_paid: userDefaultPlan?.is_paid,
      is_subscription_active: userDefaultPlan?.is_subscription_active,
      unlimited_items: userDefaultPlan?.unlimited_items,
      max_inventory_items: userDefaultPlan?.max_inventory_items || 0,
      max_inventory_items_ml: userDefaultPlan?.max_inventory_items_ml || 0,
      max_inventory_items_kg_pc: userDefaultPlan?.max_inventory_items_kg_pc || 0,
    };
    setUserOriginDefaultPlan(data);
    setUserDefaultPlan(data);
  }
  
  useEffect(() => {
    if (userDetails) {
      setUserDataActivity(userDetails?.userInformation?.active);
      getUserDefaultPlan(userDetails?.userDefaultPlan);
      setUserBillingEmailsData(userDetails?.userBillingEmails || []);
      const billingEmails = userDetails?.userBillingEmails || [];
      const includeAdminFromSettings =
        billingEmails.length === 0
          ? true
          : (userDetails?.billingEmailSettings?.includeAdminInBillingEmails ??
            userDetails?.userInformation?.include_admin_in_billing_emails);
      if (typeof includeAdminFromSettings === "boolean") {
        setIsSendAdminEmail(includeAdminFromSettings);
      } else {
        const adminBillingEmail = billingEmails.find((item) => item.is_admin);
        if (adminBillingEmail) {
          setIsSendAdminEmail(adminBillingEmail?.is_send_admin_email);
        } else if (!billingEmails.length) {
          setIsSendAdminEmail(true);
        }
      }
    }
  }, [userDetails]);

  useEffect(() => {
    if (typeof userDataActivity === "boolean") {
      setActionType(
        !userDataActivity ? BUTTONS_TYPE.active : BUTTONS_TYPE.deactive
      );
    }
  }, [userDataActivity]);

  useEffect(() => {
    if (location) {
      setUserId(paramsUserId);
    }
  }, [location, paramsUserId]);

  useEffect(() => {
    if (userId) {
      fetUserDetails(userId);
      fetchUserBranches(userId, analyticsDate);
      fetchPlans();
    }
  }, [userId, analyticsDate]);

  const closeEditUserDefaultPlanModal = () => {
    setIsOpenEditUserDefaultPlanModal(false);
    setLoadingUpdateUserDefaultPlan(false);
    setUserDefaultPlan(userOriginDefaultPlan);
  };

  const isValidUserDefaultPlanFreeTrial = () => {
    setErrorUserDefaultPlan(null);
    if(userDefaultPlan?.is_use_free_trial) {
      if(!userDefaultPlan?.free_trial_start_at || !userDefaultPlan?.free_trial_end_at) {
        setErrorUserDefaultPlan(translation.please_select_free_trial_date);
        return false;
      }
    }
    return true;
  }

  const handleUpdateUserDefaultPlanAction = (e) => {
    e.preventDefault();
    if(!isValidUserDefaultPlanFreeTrial()) {
      return;
    }
    setLoadingUpdateUserDefaultPlan(true)
    const data = {
      user_id: userId,
      plan_id: userDefaultPlan?.plan_id,
      billing_period: userDefaultPlan?.plan_type || 'monthly',
      price_paid: userDefaultPlan?.price,
      currency_id: userDefaultPlan?.currency || 1,
      trial_period_days: userDefaultPlan?.trial_period_days || 14,
      is_use_free_trial: userDefaultPlan?.is_use_free_trial,
      free_trial_start_at: userDefaultPlan?.free_trial_start_at,
      free_trial_end_at: userDefaultPlan?.free_trial_end_at,
      unlimited_items: userDefaultPlan?.unlimited_items,
      max_inventory_items: userDefaultPlan?.max_inventory_items,
      max_inventory_items_ml: userDefaultPlan?.max_inventory_items_ml,
      max_inventory_items_kg_pc: userDefaultPlan?.max_inventory_items_kg_pc,
    };
    Api.main
      .updateUserDefaultPlan(data)
      .then((res) => {
        if(res?.success) {
          const originData = {
            plan_name: userDefaultPlan?.plan_name,
            plan_id: userDefaultPlan?.plan_id,
            plan_type: userDefaultPlan?.plan_type,
            price: userDefaultPlan?.price,
            currency: userDefaultPlan?.currency,
            trial_period_days: userDefaultPlan?.trial_period_days,
            is_use_free_trial: userDefaultPlan?.is_use_free_trial,
            free_trial_start_at: userDefaultPlan?.free_trial_start_at,
            free_trial_end_at: userDefaultPlan?.free_trial_end_at,
            billing_expiration_date: userDefaultPlan?.billing_expiration_date,
            subscription_starts_at: userDefaultPlan?.subscription_starts_at,
            subscription_ends_at: userDefaultPlan?.subscription_ends_at,
            is_paid: userDefaultPlan?.is_paid,
            is_subscription_active: userDefaultPlan?.is_subscription_active,
            unlimited_items: userDefaultPlan?.unlimited_items,
            max_inventory_items: userDefaultPlan?.max_inventory_items || 0,
            max_inventory_items_ml: userDefaultPlan?.max_inventory_items_ml || 0,
            max_inventory_items_kg_pc: userDefaultPlan?.max_inventory_items_kg_pc || 0,
          };
          setUserOriginDefaultPlan(originData);
        }
        setIsOpenEditUserDefaultPlanModal(false);
      })
      .finally(() => {
        setLoadingUpdateUserDefaultPlan(false)
      });
  }

  const getPlanData = (planId) => {
    const plan = plans.find((p) => p.id === planId);
    const price = plan?.prices?.[0];
    const currency = currencies?.find((c) => c.code === price?.currency)
    const data = {
      plan_id: plan?.id,
      plan_name: plan?.name,
      plan_type: price?.billing_period || "monthly",
      price: price?.price || 0,
      currency: currency?.id,
      is_use_free_trial: false,
      trial_period_days: plan?.settings?.trial_period_days || 0,
      unlimited_items: plan?.settings?.unlimited_items || 0,
      max_inventory_items: plan?.settings?.max_inventory_items || 0,
      max_inventory_items_ml: plan?.settings?.max_inventory_items_ml || 0,
      max_inventory_items_kg_pc: plan?.settings?.max_inventory_items_kg_pc || 0,
    };
    return data;    
  }

  const handleChangePlanData = (field, value) => {
    if(['free_trial_start_at', 'free_trial_end_at'].includes(field)) {
      setErrorUserDefaultPlan(null);
    }
    
    if(field === 'plan_id') {
      const planData = getPlanData(value);
      setUserDefaultPlan({...planData});
      return;
    }
    setUserDefaultPlan((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const openAddNewBillingEmailModal = () => {    
    setSelectedBillingEmail(null);
    setIsBillingEmailEditMode(false);
    setIsBillingEmailMode(true);
    setIsSendAdminEmail(false);
    setIsAdminBillingEmail(false);
  }

  const openEditBillingEmailModal = (id) => {
    const billingEmail = userBillingEmailsData?.find((e) => e.id === id);

    setSelectedBillingEmail(billingEmail);
    setIsAdminBillingEmail(!!billingEmail?.is_admin);
    setIsSendAdminEmail(
      typeof billingEmail?.is_send_admin_email === "boolean"
        ? billingEmail.is_send_admin_email
        : (billingEmailSettings?.includeAdminInBillingEmails ??
            userInformation?.include_admin_in_billing_emails ??
            true)
    );
    setIsBillingEmailEditMode(true);
    setIsBillingEmailMode(true);
  }

  const openUserBillingEmailsEditModal = () => {

  }

  const handlerAddNewBillingEmail = () => {
    // const newBillingEmail = {
    //   email: '',
    // }
    // const data = {
    //   user_id: userId,
    //   email: newBillingEmail,
    // };
    // if(newBillingEmail) {
    //   setAdd(
    //     Api.userBillingEmails.create(data).then(() => {fetUserDetails(userId)})
    //   );
    // }

  }

  const handlerUserBillingEmailsEdit = () => {
    
  }
  
  const openUserBillingEmailsDeleteModal = () => {

  }

  const handlerUserBillingEmailsDelete = (id) => {
    console.log('id', id);
    if(id) {
      setRemove(() => () => Api.userBillingEmails.delete(id).then(() => {fetUserDetails(userId)}));
    } else {
      const billingEmails = userBillingEmails.filter(item => item.id !== id);
      setUserBillingEmailsData(billingEmails);
    }
  }

  const handlerUserBillingEmailsResend = (id) => {
    if (id) {
      Api.userBillingEmails
        .resend(id)
        .then(() => fetUserDetails(userId))
        .catch(() => setErrorMsg(BILLING_EMAIL_ERROR_MSG));
    }
  };

  const handlerToggleSendAdminBillingEmail = async (checked) => {
    if (!userId || isTogglingSendAdminBillingEmail) {
      return;
    }
    if (!checked && !userBillingEmailsData?.length) {
      return;
    }
    setIsTogglingSendAdminBillingEmail(true);
    try {
      await Api.main.updateBillingEmailAdminInclusion({
        clientId: userId,
        includeAdminInBillingEmails: checked,
      });
      setIsSendAdminEmail(checked);
      const { data } = await Api.main.getUserDetails(userId);
      setUserDetails(data);
    } catch (error) {
      setErrorMsg(BILLING_EMAIL_ERROR_MSG);
    } finally {
      setIsTogglingSendAdminBillingEmail(false);
    }
  };
  

  return loading ? (
    <div className="d-flex align-items-center flex-column px-4">
      <ClipLoader color={"#3c44b1"} loading={true} />
    </div>
  ) : (
    <>
      <UserDetailsWrapper
        companyName={companyInformation?.company_name}
        status={userDataActivity ? translation.active : translation.inactive}
        isActive={!userDataActivity}
        setIsOpenAction={setIsOpenAction}
        userId={userId}
        setActionUserId={setActionUserId}
        setActionType={setActionType}
        setIsUserActive={setIsUserActive}
        setUserDetails={setUserDetails}
        companyUserStatus={userInformation?.status}
        companyInformation={companyInformation}
        plans={plans}
        currencies={currencies}
        isShowPlans
      />
      <UserInfo
        firstName={userInformation?.name}
        lastName={userInformation?.surname}
        phoneNumber={userInformation?.phone}
        tempEmail={userInformation?.temp_email}
        email={userInformation?.email}
        registrationDate={getDate(userInformation?.created_at)}
        businessAddress={companyInformation?.business_address}
        taxCode={companyInformation?.tax_code}
        promoCode={userDetails?.promoDiscount?.code}
        dealerCode={userDetails?.dealerCode?.code}
        ambassadorCode={userDetails?.ambassadorDiscount?.code}
        branches={companyInformation?.branches_count}
        remaining_branches={remainingBranchesCount}
        setIsBranchCountMode={setIsBranchCountMode}
        setIsChangeEmailMode={setIsChangeEmailMode}
        setIsPromoCodeMode={setIsPromoCodeMode}
        setIsDealerCodeMode={setIsDealerCodeMode}
        setIsAmbassadorCodeMode={setIsAmbassadorCodeMode}
        contractNumber={companyInformation?.manual_transfer_invoice_number}
        setIsContractNumberMode={setIsContractNumberMode}
        billingExpirationDate={getDate(userInformation?.billing_expiration_date)}
        setIsChangeBillingExpirationDateMode={setIsChangeBillingExpirationDateMode}
      />
      <UserBillingEmails
        emailsData={userBillingEmailsData}
        billingEmailSettings={billingEmailSettings}
        setUserDetails={setUserDetails}
        showAddButton={true}
        addButtonText={translation.add}
        handlerAddNewBillingEmail={openAddNewBillingEmailModal}
        editHandler={openEditBillingEmailModal}
        deleteHandler={handlerUserBillingEmailsDelete}
        resendHandler={handlerUserBillingEmailsResend}
        loadingDelete={loadingUserBillingEmailsDelete}
        onToggleSendAdminBillingEmail={
          billingEmailSettings ? handlerToggleSendAdminBillingEmail : undefined
        }
        isTogglingSendAdminBillingEmail={isTogglingSendAdminBillingEmail}
      />
      <UserDefaultPlan
        plan={userDefaultPlan}
        actionHandler={() => setIsOpenEditUserDefaultPlanModal(true)}
      />
      <UsersInformation
        setIsOpenAction={setIsOpenAction}
        usersList={companyUsers}
        setActionUserId={setActionUserId}
        setActionType={setActionType}
        setIsUserActive={setIsUserActive}
        setUserDetails={setUserDetails}
        plans={plans}
      />
      <UserBranches
        branchList={userBranches}
        setIsOpenBranchAction={setIsOpenBranchAction}
        setBranchId={setBranchId}
        setBranchActionType={setBranchActionType}
        setIsBranchActive={setIsBranchActive}
        setUserDetails={setUserDetails}
        setIsActionActive={setBranchIsActionActive}
        handleDateChange={setAnalyticsDate}
        plans={plans}
        currencies={currencies}
      />
      {isOpenBranchAction && (
        <ActiveDeactivatedConfirm
          setIsOpenAction={setIsOpenBranchAction}
          isOpenAction={isOpenBranchAction}
          onClickHandler={handleBranchActivation}
          actionType={branchActionType}
          name={translation.branch}
          isActionActive={!isBranchActionActive}
        />
      )}
      {isOpenAction && (
        <ActiveDeactivatedConfirm
          setIsOpenAction={setIsOpenAction}
          isOpenAction={isOpenAction}
          onClickHandler={onClickHandler}
          actionType={actionType}
          name={translation.user}
          isShowLanguage
          lang={lang}
          setLang={setLang}
          isActionActive={isUserActive}
          loading={activateLoading}
        />
      )}
      {isPromoCodeMode && (
        <PromoCode
          isPromoCodeMode={isPromoCodeMode}
          setIsPromoCodeMode={setIsPromoCodeMode}
          setUserDetails={setUserDetails}
          promo_code={userDetails?.promoDiscount?.code}
        />
      )}
      {isDealerCodeMode && (
        <LinkedCode
          open={isDealerCodeMode}
          setOpen={setIsDealerCodeMode}
          setUserDetails={setUserDetails}
          currentCode={userDetails?.dealerCode?.code}
          title={translation.dealer_code}
          fieldId="dealer-code-field"
          emptyErrorMessage={DEALER_CODE_ERROR_MSG}
          allowEmpty
          updateRequest={(clientId, dealerCode) => {
            const normalizedCode = String(dealerCode || "").trim();
            return Api.main.updateDealerCode(
              normalizedCode
                ? { clientId, dealerCode: normalizedCode }
                : {
                    clientId,
                    dealerCode: null,
                    dealerCodeId: null,
                    clearDealerCode: true,
                  }
            );
          }}
        />
      )}
      {isAmbassadorCodeMode && (
        <LinkedCode
          open={isAmbassadorCodeMode}
          setOpen={setIsAmbassadorCodeMode}
          setUserDetails={setUserDetails}
          currentCode={userDetails?.ambassadorDiscount?.code}
          title={translation.ambassador_code}
          fieldId="ambassador-code-field"
          emptyErrorMessage={AMBASSADOR_CODE_ERROR_MSG}
          allowEmpty
          updateRequest={(clientId, ambassadorCode) =>
            Api.main.updateAmbassadorCode({
              clientId,
              ambassadorCode: ambassadorCode || null,
            })
          }
        />
      )}
      {isContractNumberMode && (
        <LinkedCode
          open={isContractNumberMode}
          setOpen={setIsContractNumberMode}
          setUserDetails={setUserDetails}
          currentCode={companyInformation?.manual_transfer_invoice_number}
          title={translation.contract_number}
          fieldId="contract-number-field"
          emptyErrorMessage={CONTRACT_NUMBER_ERROR_MSG}
          allowEmpty
          helperText={translation.contract_number_format_hint}
          updateRequest={(clientId, transferInvoiceNumber) =>
            Api.main.updateTransferInvoiceNumber({
              clientId,
              transferInvoiceNumber: transferInvoiceNumber || null,
            })
          }
        />
      )}
      {isBranchCountMode && (
        <BranchCount
          isBranchCountMode={isBranchCountMode}
          setIsBranchCountMode={setIsBranchCountMode}
          setUserDetails={setUserDetails}
          branches_count={companyInformation?.branches_count}
        />
      )}

      {isChangeEmailMode && (
        <ChangeEmail
          isChangeEmailMode={isChangeEmailMode}
          setIsChangeEmailMode={setIsChangeEmailMode}
          userEmail={userInformation?.temp_email || userInformation?.email}
          fetUserDetails={fetUserDetails}
        />
      )}
      {isBillingEmailMode && (
        <UserBillingEmail
          isBillingEmailMode={isBillingEmailMode}
          setIsBillingEmailMode={setIsBillingEmailMode}
          setUserDetails={setUserDetails}
          user_billing_email={selectedBillingEmail?.email}
          user_billing_email_id={selectedBillingEmail?.id}
          isEditMode={isBillingEmailEditMode}
          isAdminEmail={isAdminBillingEmail}
          isSendAdminEmail={isSendAdminEmail}
          setIsSendAdminEmail={setIsSendAdminEmail}
        />
      )}
      {isChangeBillingExpirationDateMode && (
        <BillingExpirationDate
          isChangeBillingExpirationDateMode={isChangeBillingExpirationDateMode}
          setIsChangeBillingExpirationDateMode={setIsChangeBillingExpirationDateMode}
          setUserDetails={setUserDetails}
          billing_expiration_date={userInformation?.billing_expiration_date}
        />
      )}
      {
        !!isOpenEditUserDefaultPlanModal && (
          <AcceptUserModal
            isUserModal={false}
            isShowPlans={true}
            isShowFreeTrial={true}
            isOpen={isOpenEditUserDefaultPlanModal}
            close={closeEditUserDefaultPlanModal}
            accept={handleUpdateUserDefaultPlanAction}
            text={translation.edit_user_default_plan}
            loading={loadingUpdateUserDefaultPlan}
            plans={plans}
            currencies={currencies}
            handleChangePlanData={handleChangePlanData}
            planData={userDefaultPlan}
            errorUserDefaultPlan={errorUserDefaultPlan}
          />
        )
      }
    </>
  );
}
